import { CategoryRecord, CategoryState } from './categories.state';
import * as actions from './categories.actions';
import { CatModel, PdfItemModel, SlideModel, SliderItemModel } from './categories.models';

export const initialState: CategoryState = (new CategoryRecord() as unknown) as CategoryState;

export function reducer(state = initialState, { type, payload }: any): CategoryState {
    if (!type) {
        return state;
    }

    switch (type) {
        case actions.ActionTypes.CREATE_CATEGORY: {
            return Object.assign({}, state, {
                createCategoriesLoading: true,
                createCategoriesData: null,
                createCategoriesFailData: null,
            })
        }
        case actions.ActionTypes.CREATE_CATEGORY_SUCCESS: {
            let data;
            let err;
            if (payload.success && payload.data) {
                data = new CatModel(payload.data);
            }
            return Object.assign({}, state, {
                createCategoriesLoading: false,
                createCategoriesData: data,
                createCategoriesFailData: err,
            })
        }
        case actions.ActionTypes.CREATE_CATEGORY_FAIL: {
            return Object.assign({}, state, {
                createCategoriesLoading: false,
                createCategoriesData: null,
                createCategoriesFailData: payload,
            })
        }
        case actions.ActionTypes.CLEAR_CREATE_CATEGORY_STATE: {
            return Object.assign({}, state, {
                createCategoriesLoading: false,
                createCategoriesData: null,
                createCategoriesFailData: null,
            })
        }

        case actions.ActionTypes.GET_CATEGORIES_LIST: {
            return Object.assign({}, state, {
                getCategoriesListLoading: true,
                getCategoriesListData: null,
                getCategoriesListFailData: null,
            })
        }
        case actions.ActionTypes.GET_CATEGORIES_LIST_FAIL: {
            return Object.assign({}, state, {
                getCategoriesListLoading: false,
                getCategoriesListData: null,
                getCategoriesListFailData: payload,
            })
        }
        case actions.ActionTypes.GET_CATEGORIES_LIST_SUCCESS: {
            let data;
            let err;
            if (payload.success && payload.data) {
                data = payload.data.map((el: any) => new CatModel(el));
            } else {
                err = payload;
            }
            return Object.assign({}, state, {
                getCategoriesListLoading: false,
                getCategoriesListData: data,
                getCategoriesListFailData: err,
            })
        }

        case actions.ActionTypes.GET_CATEGORIES_ITEM: {
            return Object.assign({}, state, {
                getCategoriesItemLoading: true,
                getCategoriesItemData: null,
                getCategoriesItemFailData: null,
            })
        }
        case actions.ActionTypes.GET_CATEGORIES_ITEM_SUCCESS: {
            return Object.assign({}, state, {
                getCategoriesItemLoading: false,
                getCategoriesItemData: payload,
                getCategoriesItemFailData: null,
            })
        }
        case actions.ActionTypes.GET_CATEGORIES_ITEM_FAIL: {
            return Object.assign({}, state, {
                getCategoriesItemLoading: false,
                getCategoriesItemData: null,
                getCategoriesItemFailData: payload,
            })
        }
        case actions.ActionTypes.CLEAR_GET_CATEGORIES_ITEM_STATE: {
            return Object.assign({}, state, {
                getCategoriesItemLoading: false,
                getCategoriesItemData: null,
                getCategoriesItemFailData: null,
            })
        }

        case actions.ActionTypes.UPDATE_CATEGORIES_ITEM: {
            return Object.assign({}, state, {
                updateCategoriesItemLoading: true,
                updateCategoriesItemData: null,
                updateCategoriesItemFailData: null,
            })
        }
        case actions.ActionTypes.UPDATE_CATEGORIES_ITEM_SUCCESS: {
            return Object.assign({}, state, {
                updateCategoriesItemLoading: false,
                updateCategoriesItemData: payload,
                updateCategoriesItemFailData: null,
            })
        }
        case actions.ActionTypes.UPDATE_CATEGORIES_ITEM_FAIL: {
            return Object.assign({}, state, {
                updateCategoriesItemLoading: false,
                updateCategoriesItemData: null,
                updateCategoriesItemFailData: payload,
            })
        }
        case actions.ActionTypes.CLEAR_UPDATE_CATEGORIES_ITEM_STATE: {
            return Object.assign({}, state, {
                updateCategoriesItemLoading: false,
                updateCategoriesItemData: null,
                updateCategoriesItemFailData: null,
            })
        }

        case actions.ActionTypes.REMOVE_CATEGORIES_ITEM: {
            return Object.assign({}, state, {
                deleteCategoriesItemLoading: true,
                deleteCategoriesItemData: null,
                deleteCategoriesItemFailData: null,
            })
        }
        case actions.ActionTypes.REMOVE_CATEGORIES_ITEM_SUCCESS: {
            return Object.assign({}, state, {
                deleteCategoriesItemLoading: false,
                deleteCategoriesItemData: payload,
                deleteCategoriesItemFailData: null,
            })
        }
        case actions.ActionTypes.REMOVE_CATEGORIES_ITEM_FAIL: {
            return Object.assign({}, state, {
                deleteCategoriesItemLoading: false,
                deleteCategoriesItemData: null,
                deleteCategoriesItemFailData: payload,
            })
        }
        case actions.ActionTypes.CLEAR_REMOVE_CATEGORIES_ITEM_STATE: {
            return Object.assign({}, state, {
                deleteCategoriesItemLoading: false,
                deleteCategoriesItemData: null,
                deleteCategoriesItemFailData: null,
            })
        }


        case actions.ActionTypes.CREATE_SLIDER_ITEMS: {
            return Object.assign({}, state, {
                createSliderItemLoading: true,
                createSliderItemData: null,
                createSliderItemFailData: null,
            })
        }
        case actions.ActionTypes.CREATE_SLIDER_ITEMS_SUCCESS: {
            let data;
            let err;
            if (payload.success && payload.data) {
                data = new SliderItemModel(payload.data);
            } else {
                err = payload;
            }
            console.log('>>>data', data);
            return Object.assign({}, state, {
                createSliderItemLoading: false,
                createSliderItemData: data,
                createSliderItemFailData: err,
            })
        }
        case actions.ActionTypes.CREATE_SLIDER_ITEMS_FAIL: {
            return Object.assign({}, state, {
                createSliderItemLoading: false,
                createSliderItemData: null,
                createSliderItemFailData: payload,
            })
        }
        case actions.ActionTypes.CLEAR_CREATE_SLIDER_ITEMS_STATE: {
            return Object.assign({}, state, {
                createSliderItemLoading: false,
                createSliderItemData: null,
                createSliderItemFailData: null,
            })
        }

        case actions.ActionTypes.GET_SLIDER_ITEM: {
            return Object.assign({}, state, {
                getSliderItemLoading: true,
                getSliderItemData: null,
                getSliderItemFailData: null,
            })
        }
        case actions.ActionTypes.GET_SLIDER_ITEM_SUCCESS: {
            let data;
            let err;
            if (payload.success && payload.data) {
                data = payload.data;
            } else {
                err = payload;
            }
            return Object.assign({}, state, {
                getSliderItemLoading: false,
                getSliderItemData: data,
                getSliderItemFailData: err,
            })
        }
        case actions.ActionTypes.GET_SLIDER_ITEM_FAIL: {
            return Object.assign({}, state, {
                getSliderItemLoading: false,
                getSliderItemData: null,
                getSliderItemFailData: payload,
            })
        }
        case actions.ActionTypes.CLEAR_GET_SLIDER_ITEM_STATE: {
            return Object.assign({}, state, {
                getSliderItemLoading: false,
                getSliderItemData: null,
                getSliderItemFailData: null,
            })
        }

        case actions.ActionTypes.GET_SLIDER_LIST: {
            return Object.assign({}, state, {
                getSliderListLoading: true,
                getSliderListData: null,
                getSliderListFailData: null,
            })
        }
        case actions.ActionTypes.GET_SLIDER_LIST_SUCCESS: {
            let data;
            let err;
            if (payload.success && payload.data) {
                data = payload.data;
            } else {
                err = payload;
            }
            return Object.assign({}, state, {
                getSliderListLoading: false,
                getSliderListData: data,
                getSliderListFailData: err,
            })
        }
        case actions.ActionTypes.GET_SLIDER_LIST_FAIL: {
            return Object.assign({}, state, {
                getSliderListLoading: false,
                getSliderListData: null,
                getSliderListFailData: payload,
            })
        }
        case actions.ActionTypes.CLEAR_GET_SLIDER_LIST_STATE: {
            return Object.assign({}, state, {
                getSliderListLoading: false,
                getSliderListData: null,
                getSliderListFailData: null,
            })
        }

        case actions.ActionTypes.REMOVE_SLIDER_ITEM: {
            return Object.assign({}, state, {
                removeSliderItemLoading: true,
                removeSliderItemData: null,
                removeSliderItemFailData: null,
            })
        }
        case actions.ActionTypes.REMOVE_SLIDER_ITEM_SUCCESS: {
            let data;
            let err;
            if (payload.success && payload.data) {
                data = payload.data;
            } else {
                err = payload;
            }
            return Object.assign({}, state, {
                removeSliderItemLoading: false,
                removeSliderItemData: data,
                removeSliderItemFailData: err,
            })
        }
        case actions.ActionTypes.REMOVE_SLIDER_ITEM_FAIL: {
            return Object.assign({}, state, {
                removeSliderItemLoading: false,
                removeSliderItemData: null,
                removeSliderItemFailData: payload,
            })
        }
        case actions.ActionTypes.CLEAR_REMOVE_SLIDER_ITEM_STATE: {
            return Object.assign({}, state, {
                removeSliderItemLoading: false,
                removeSliderItemData: null,
                removeSliderItemFailData: null,
            })
        }

        case actions.ActionTypes.UPDATE_SLIDER_ITEM: {
            return Object.assign({}, state, {
                updateSliderItemLoading: true,
                updateSliderItemData: null,
                updateSliderItemFailData: null,
            })
        }
        case actions.ActionTypes.UPDATE_SLIDER_ITEM_SUCCESS: {
            let data;
            let err;
            if (payload.success && payload.data) {
                data = payload.data;
            } else {
                err = payload;
            }
            return Object.assign({}, state, {
                updateSliderItemLoading: false,
                updateSliderItemData: data,
                updateSliderItemFailData: err,
            })
        }
        case actions.ActionTypes.UPDATE_SLIDER_ITEM_FAIL: {
            return Object.assign({}, state, {
                updateSliderItemLoading: false,
                updateSliderItemData: null,
                updateSliderItemFailData: payload,
            })
        }
        case actions.ActionTypes.CLEAR_UPDATE_SLIDER_ITEM_STATE: {
            return Object.assign({}, state, {
                updateSliderItemLoading: false,
                updateSliderItemData: null,
                updateSliderItemFailData: null,
            })
        }

        case actions.ActionTypes.CREATE_PDF_ITEM: {
            return Object.assign({}, state, {
                createPdfItemLoading: true,
                createPdfItemData: null,
                createPdfItemFailData: null,
            })
        }
        case actions.ActionTypes.CREATE_PDF_ITEM_SUCCESS: {
            let data;
            let err;
            if (payload.success && payload.data) {
                data = new PdfItemModel(payload.data);
            } else {
                err = payload;
            }
            return Object.assign({}, state, {
                createPdfItemLoading: false,
                createPdfItemData: data,
                createPdfItemFailData: err,
            })
        }
        case actions.ActionTypes.CREATE_PDF_ITEM_FAIL: {
            return Object.assign({}, state, {
                createPdfItemLoading: false,
                createPdfItemData: null,
                createPdfItemFailData: payload,
            })
        }
        case actions.ActionTypes.CLEAR_CREATE_PDF_ITEM_STATE: {
            return Object.assign({}, state, {
                createPdfItemLoading: false,
                createPdfItemData: null,
                createPdfItemFailData: null,
            })
        }

        case actions.ActionTypes.DELETE_PDF_ITEM: {
            return Object.assign({}, state, {
                deletePdfItemLoading: true,
                deletePdfItemData: null,
                deletePdfItemFailData: null,
            })
        }
        case actions.ActionTypes.DELETE_PDF_ITEM_SUCCESS: {
            let data;
            let err;
            if (payload.success && payload.data) {
                data = payload.data;
            } else {
                err = payload;
            }
            return Object.assign({}, state, {
                deletePdfItemLoading: false,
                deletePdfItemData: data,
                deletePdfItemFailData: err,
            })
        }
        case actions.ActionTypes.DELETE_PDF_ITEM_FAIL: {
            return Object.assign({}, state, {
                deletePdfItemLoading: false,
                deletePdfItemData: null,
                deletePdfItemFailData: payload,
            })
        }
        case actions.ActionTypes.CLEAR_DELETE_PDF_ITEM_STATE: {
            return Object.assign({}, state, {
                deletePdfItemLoading: false,
                deletePdfItemData: null,
                deletePdfItemFailData: null,
            })
        }

        case actions.ActionTypes.UPDATE_PDF_ITEM: {
            return Object.assign({}, state, {
                updatePdfItemLoading: true,
                updatePdfItemData: null,
                updatePdfItemFailData: null,
            })
        }
        case actions.ActionTypes.UPDATE_PDF_ITEM_SUCCESS: {
            let data;
            let err;
            if (payload.success && payload.data) {
                data = new PdfItemModel(payload.data);
            } else {
                err = payload;
            }
            return Object.assign({}, state, {
                updatePdfItemLoading: false,
                updatePdfItemData: data,
                updatePdfItemFailData: err,
            })
        }
        case actions.ActionTypes.UPDATE_PDF_ITEM_FAIL: {
            return Object.assign({}, state, {
                updatePdfItemLoading: false,
                updatePdfItemData: null,
                updatePdfItemFailData: payload,
            })
        }
        case actions.ActionTypes.CLEAR_UPDATE_PDF_ITEM_STATE: {
            return Object.assign({}, state, {
                updatePdfItemLoading: false,
                updatePdfItemData: null,
                updatePdfItemFailData: null,
            })
        }

        case actions.ActionTypes.GET_PDF_ITEM: {
            return Object.assign({}, state, {
                getPdfItemLoading: true,
                getPdfItemData: null,
                getPdfItemFailData: null,
            })
        }
        case actions.ActionTypes.GET_PDF_ITEM_SUCCESS: {
            let data;
            let err;
            if (payload.success && payload.data) {
                data = new PdfItemModel(payload.data);
            } else {
                err = payload;
            }
            return Object.assign({}, state, {
                getPdfItemLoading: false,
                getPdfItemData: data,
                getPdfItemFailData: err,
            })
        }
        case actions.ActionTypes.GET_PDF_ITEM_FAIL: {
            return Object.assign({}, state, {
                getPdfItemLoading: false,
                getPdfItemData: null,
                getPdfItemFailData: payload,
            })
        }
        case actions.ActionTypes.CLEAR_GET_PDF_ITEM_STATE: {
            return Object.assign({}, state, {
                getPdfItemLoading: false,
                getPdfItemData: null,
                getPdfItemFailData: null,
            })
        }

        case actions.ActionTypes.GET_PDF_LIST: {
            return Object.assign({}, state, {
                getPdfListLoading: true,
                getPdfListData: null,
                getPdfListFailData: null,
                getPdfListCount: 0,
            });
        }
        case actions.ActionTypes.GET_PDF_LIST_SUCCESS: {
            let data;
            let err;
            let count = 0;
            if (payload.success && payload.data && payload.data.length) {
                data = payload.data.map((el: any) => new PdfItemModel(el));
            } else {
                err = payload;
            }
            if (!!payload.success && payload.count) {
                count = payload.count || 0;
            }
            return Object.assign({}, state, {
                getPdfListLoading: false,
                getPdfListData: data,
                getPdfListFailData: err,
                getPdfListCount: count,
            });
        }
        case actions.ActionTypes.GET_PDF_LIST_FAIL: {
            return Object.assign({}, state, {
                getPdfListLoading: false,
                getPdfListData: null,
                getPdfListFailData: payload,
                getPdfListCount: 0,
            });
        }
        case actions.ActionTypes.CLEAR_GET_PDF_LIST_STATE: {
            return Object.assign({}, state, {
                getPdfListLoading: false,
                getPdfListData: null,
                getPdfListFailData: null
            });
        }

        case actions.ActionTypes.CREATE_SLIDER: {
            return Object.assign({}, state, {
                createSliderLoading: true,
                createSliderData: null,
                createSliderFailData: null,
            })
        }
        case actions.ActionTypes.CREATE_SLIDER_SUCCESS: {
            let data;
            let err;
            if (payload.success && payload.data) {
                data = new SlideModel(payload.data);
            } else {
                err = payload;
            }
            return Object.assign({}, state, {
                createSliderLoading: false,
                createSliderData: data,
                createSliderFailData: err,
            })
        }
        case actions.ActionTypes.CREATE_SLIDER_FAIL: {
            return Object.assign({}, state, {
                createSliderLoading: false,
                createSliderData: null,
                createSliderFailData: payload,
            })
        }
        case actions.ActionTypes.CLEAR_CREATE_SLIDER_STATE: {
            return Object.assign({}, state, {
                createSliderLoading: false,
                createSliderData: null,
                createSliderFailData: null,
            })
        }

        case actions.ActionTypes.UPDATE_SLIDER: {
            return Object.assign({}, state, {
                updateSliderLoading: true,
                updateSliderData: null,
                updateSliderFailData: null,
            })
        }
        case actions.ActionTypes.UPDATE_SLIDER_SUCCESS: {
            let data;
            let err;
            if (payload.success && payload.data) {
                data = new SlideModel(payload.data);
            } else {
                err = payload;
            }
            return Object.assign({}, state, {
                updateSliderLoading: false,
                updateSliderData: data,
                updateSliderFailData: err,
            })
        }
        case actions.ActionTypes.UPDATE_SLIDER_FAIL: {
            return Object.assign({}, state, {
                updateSliderLoading: false,
                updateSliderData: null,
                updateSliderFailData: payload,
            })
        }
        case actions.ActionTypes.CLEAR_UPDATE_SLIDER_STATE: {
            return Object.assign({}, state, {
                updateSliderLoading: false,
                updateSliderData: null,
                updateSliderFailData: null,
            })
        }

        case actions.ActionTypes.REMOVE_SLIDER: {
            return Object.assign({}, state, {
                removeSliderLoading: true,
                removeSliderData: null,
                removeSliderFailData: null,
            })
        }
        case actions.ActionTypes.REMOVE_SLIDER_SUCCESS: {
            let data;
            let err;
            if (payload.success && payload.data) {
                data = payload.data;
            } else {
                err = payload;
            }
            return Object.assign({}, state, {
                removeSliderLoading: false,
                removeSliderData: data,
                removeSliderFailData: err,
            })
        }
        case actions.ActionTypes.REMOVE_SLIDER_FAIL: {
            return Object.assign({}, state, {
                removeSliderLoading: false,
                removeSliderData: null,
                removeSliderFailData: payload,
            })
        }
        case actions.ActionTypes.CLEAR_REMOVE_SLIDER_STATE: {
            return Object.assign({}, state, {
                removeSliderLoading: false,
                removeSliderData: null,
                removeSliderFailData: null,
            })
        }

        case actions.ActionTypes.GET_SLIDER: {
            return Object.assign({}, state, {
                getSliderLoading: true,
                getSliderData: null,
                getSliderFailData: null,
            })
        }
        case actions.ActionTypes.GET_SLIDER_SUCCESS: {
            let data;
            let err;
            if (payload.success && payload.data) {
                data = new SlideModel(payload.data);
            } else {
                err = payload;
            }
            return Object.assign({}, state, {
                getSliderLoading: false,
                getSliderData: data,
                getSliderFailData: err,
            })
        }
        case actions.ActionTypes.GET_SLIDER_FAIL: {
            return Object.assign({}, state, {
                getSliderLoading: false,
                getSliderData: null,
                getSliderFailData: payload,
            })
        }
        case actions.ActionTypes.CLEAR_GET_SLIDER_STATE: {
            return Object.assign({}, state, {
                getSliderLoading: false,
                getSliderData: null,
                getSliderFailData: null,
            })
        }
        // 
        case actions.ActionTypes.GET_SLIDERS: {
            return Object.assign({}, state, {
                getSlidersLoading: true,
                getSlidersData: null,
                getSlidersFailData: null,
            })
        }
        case actions.ActionTypes.GET_SLIDERS_SUCCESS: {
            let data;
            let err;
            if (payload.success && payload.data && payload.data.sliders) {
                data = payload.data.sliders.map((el: any) => new SlideModel(el));
            } else {
                err = payload;
            }
            return Object.assign({}, state, {
                getSlidersLoading: false,
                getSlidersData: data,
                getSlidersFailData: err,
            })
        }
        case actions.ActionTypes.GET_SLIDERS_FAIL: {
            return Object.assign({}, state, {
                getSlidersLoading: false,
                getSlidersData: null,
                getSlidersFailData: payload,
            })
        }
        case actions.ActionTypes.CLEAR_GET_SLIDERS_STATE: {
            return Object.assign({}, state, {
                getSlidersLoading: false,
                getSlidersData: null,
                getSlidersFailData: null,
            })
        }

        default:
            return state;
    }
}

export const createCategoriesLoading = (state: CategoryState) => state.createCategoriesLoading;
export const createCategoriesData = (state: CategoryState) => state.createCategoriesData;
export const createCategoriesFailData = (state: CategoryState) => state.createCategoriesFailData;

export const getCategoriesListLoading = (state: CategoryState) => state.getCategoriesListLoading;
export const getCategoriesListData = (state: CategoryState) => state.getCategoriesListData;
export const getCategoriesListFailData = (state: CategoryState) => state.getCategoriesListFailData;

export const getCategoriesItemLoading = (state: CategoryState) => state.getCategoriesItemLoading;
export const getCategoriesItemData = (state: CategoryState) => state.getCategoriesItemData;
export const getCategoriesItemFailData = (state: CategoryState) => state.getCategoriesItemFailData;

export const updateCategoriesItemLoading = (state: CategoryState) => state.updateCategoriesItemLoading;
export const updateCategoriesItemData = (state: CategoryState) => state.updateCategoriesItemData;
export const updateCategoriesItemFailData = (state: CategoryState) => state.updateCategoriesItemFailData;

export const deleteCategoriesItemLoading = (state: CategoryState) => state.deleteCategoriesItemLoading;
export const deleteCategoriesItemData = (state: CategoryState) => state.deleteCategoriesItemData;
export const deleteCategoriesItemFailData = (state: CategoryState) => state.deleteCategoriesItemFailData;

export const createSliderItemLoading = (state: CategoryState) => state.createSliderItemLoading;
export const createSliderItemData = (state: CategoryState) => state.createSliderItemData;
export const createSliderItemFailData = (state: CategoryState) => state.createSliderItemFailData;

export const getSliderItemLoading = (state: CategoryState) => state.getSliderItemLoading;
export const getSliderItemData = (state: CategoryState) => state.getSliderItemData;
export const getSliderItemFailData = (state: CategoryState) => state.getSliderItemFailData;

export const getSliderListLoading = (state: CategoryState) => state.getSliderListLoading;
export const getSliderListData = (state: CategoryState) => state.getSliderListData;
export const getSliderListFailData = (state: CategoryState) => state.getSliderListFailData;

export const removeSliderItemLoading = (state: CategoryState) => state.removeSliderItemLoading;
export const removeSliderItemData = (state: CategoryState) => state.removeSliderItemData;
export const removeSliderItemFailData = (state: CategoryState) => state.removeSliderItemFailData;

export const updateSliderItemLoading = (state: CategoryState) => state.updateSliderItemLoading;
export const updateSliderItemData = (state: CategoryState) => state.updateSliderItemData;
export const updateSliderItemFailData = (state: CategoryState) => state.updateSliderItemFailData;

export const createPdfItemLoading = (state: CategoryState) => state.createPdfItemLoading;
export const createPdfItemData = (state: CategoryState) => state.createPdfItemData;
export const createPdfItemFailData = (state: CategoryState) => state.createPdfItemFailData;

export const deletePdfItemLoading = (state: CategoryState) => state.deletePdfItemLoading;
export const deletePdfItemData = (state: CategoryState) => state.deletePdfItemData;
export const deletePdfItemFailData = (state: CategoryState) => state.deletePdfItemFailData;

export const updatePdfItemLoading = (state: CategoryState) => state.updatePdfItemLoading;
export const updatePdfItemData = (state: CategoryState) => state.updatePdfItemData;
export const updatePdfItemFailData = (state: CategoryState) => state.updatePdfItemFailData;

export const getPdfItemLoading = (state: CategoryState) => state.getPdfItemLoading;
export const getPdfItemData = (state: CategoryState) => state.getPdfItemData;
export const getPdfItemFailData = (state: CategoryState) => state.getPdfItemFailData;

export const getPdfListLoading = (state: CategoryState) => state.getPdfListLoading;
export const getPdfListData = (state: CategoryState) => state.getPdfListData;
export const getPdfListFailData = (state: CategoryState) => state.getPdfListFailData;
export const getPdfListCount = (state: CategoryState) => state.getPdfListCount;

export const createSliderLoading = (state: CategoryState) => state.createSliderLoading;
export const createSliderData = (state: CategoryState) => state.createSliderData;
export const createSliderFailData = (state: CategoryState) => state.createSliderFailData;

export const updateSliderLoading = (state: CategoryState) => state.updateSliderLoading;
export const updateSliderData = (state: CategoryState) => state.updateSliderData;
export const updateSliderFailData = (state: CategoryState) => state.updateSliderFailData;

export const removeSliderLoading = (state: CategoryState) => state.removeSliderLoading;
export const removeSliderData = (state: CategoryState) => state.removeSliderData;
export const removeSliderFailData = (state: CategoryState) => state.removeSliderFailData;

export const getSliderLoading = (state: CategoryState) => state.getSliderLoading;
export const getSliderData = (state: CategoryState) => state.getSliderData;
export const getSliderFailData = (state: CategoryState) => state.getSliderFailData;

export const getSlidersLoading = (state: CategoryState) => state.getSlidersLoading;
export const getSlidersData = (state: CategoryState) => state.getSlidersData;
export const getSlidersFailData = (state: CategoryState) => state.getSlidersFailData;